import * as React from "react";
import { ExternalLink } from "../../../../newcomponents/table/components/ExternalLink";
import { DOCS_URL } from "../../../../envVariables";
import { Alert, Divider } from "antd";
import { CpInput } from "../../../gvc/testNewForm/CpInput";
import { CpFormItem } from "../../../gvc/testNewForm/CpFormItem";
import { CpLabel } from "../../../gvc/testNewForm/CpLabel";
import { CpErrorWarning } from "../../../gvc/testNewForm/CpErrorWarning";
import { useCpFormValue } from "../../../gvc/testNewForm/utils";

interface Props {}
export const AddonAwsEfs: React.FC<Props> = ({}) => {
  const isEnabled = useCpFormValue(`addons.awsEFS.isEnabled`);

  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <Divider orientation="left" orientationMargin={0}>
        Add-On | AWS EFS
      </Divider>
      <div id={`addon-awsEFS`} style={{ scrollMarginTop: 200 }}>
        <Alert
          className="mb-4 w-fit"
          type={"info"}
          message="Documentation"
          description={
            <div className="flex items-end gap-1">
              <ExternalLink url={`${DOCS_URL}/mk8s/add-ons/aws_efs`} label={`Click here`} disableCopy />
              <div>for learning how to configure the addon.</div>
            </div>
          }
        />
        <CpFormItem>
          <CpLabel name={`addons.awsEFS.roleArn`}>Role ARN</CpLabel>
          <CpInput name={`addons.awsEFS.roleArn`} style={{ maxWidth: 600 }} />
          <CpErrorWarning name={`addons.awsEFS.roleArn`} />
        </CpFormItem>
      </div>
    </>
  );
};
